import BaseCom from "../../../../components/BaseCom";
import Card from "../../../../components/Card";
import FormInputV2 from "../../../../components/FormInputV2";
import Icon from "../../../../components/Icon";
import L from "../../../../components/Lang";
import AppActions from "../../../../components/Solusek/AppActions";
import ConfirmButton from "../../../../components/Solusek/ConfirmButton";
import UForm from "../../../../components/Solusek/UForm";
import Switch from "../../../../components/Switch";
import { withParamsAndNavigate } from "../../../../components/WithParamsAndNavigate";

class UserEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>User</L></h1>
                <UForm
                    model={this.state.info}
                    api="/api/admin/user"
                    id={this.props.params.id}
                    goBack
                    onLoad={(info) => this.setState({ info })}
                    onBeforeSubmit={() => this.setState({ submitting: true})}
                    onSuccess={() => { this.setState({ submitting: false }); this.success('Saved!') } }
                    onError={() => this.setState({ submitting: false })}>
                    <Card title="Info">
                        <FormInputV2 model={this.state.info} name="email" label="Email Address" required />
                        <div className="row">
                            <div className="col-md">
                                <FormInputV2 model={this.state.info} name="firstName" label="First Name" required />
                            </div>
                            <div className="col-md">
                                <FormInputV2 model={this.state.info} name="lastName" label="Last Name" required />
                            </div>
                        </div>
                    </Card>
                    <Card title="Properties">
                        <Switch model={this.state.info} name="isInternal" label="Internal Employee" />
                    </Card>

                    <AppActions showBack>
                        <ConfirmButton submit className="btn btn-success btn-lg" disabled={this.state.submitting}><Icon icon="faSave" /> <L>Save</L></ConfirmButton>
                    </AppActions>
                </UForm>
            </div>
        )
    }
}

export default withParamsAndNavigate(UserEdit);